import { render, staticRenderFns } from "./payment-marquee.vue?vue&type=template&id=6b1dd8ab&scoped=true"
import script from "./payment-marquee.vue?vue&type=script&lang=js"
export * from "./payment-marquee.vue?vue&type=script&lang=js"
import style0 from "./payment-marquee.vue?vue&type=style&index=0&id=6b1dd8ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1dd8ab",
  null
  
)

export default component.exports